'use strict';

angular
    .module('carHire')
    .service('carHireService', carHireService);


function carHireService($q, $http, tripService, analytics) {

    var domain = TRPCONFIG.Domain,
    service = {
        getCarQuotes: getCarQuotes,
        getCarQuotesFromSession: getCarQuotesFromSession
    };

    var timeout;


    function getCarQuotes(tripId, request) {
        var req = angular.extend({
            DomainId: domain.DomainId,
            Currency: domain.CurrencyCode
        }, request);
        if (timeout != null) {
            timeout.resolve('CANCELLED');
        }
        timeout = $q.defer();
        analytics.startTimer('CarHireAvailabilityRequest');
        return $http.post('/api2/carhire/availability/get', req, {
            ignoreErrors: true,
            timeout: timeout.promise
        }).then(function (res) {
            analytics.endTimer('CarHireAvailabilityRequest');
            tripService.recordCarHireSearch(tripId, request);
            timeout = null;
            return res.data.CarHireQuotes;
        });
    }

    function getCarQuotesFromSession(request) {
        return $http.post('/api2/carhire/availability/getfromsession',
                          request,
                          { ignoreErrors: true }
        ).then(function (res) {
            return res.data.CarHireQuotes;
        });
    }
    return service;

}

angular
    .module('carHire')
    .service('carHireDetailsService', carHireDetailsService);


function carHireDetailsService($http, arrayUtil: ArrayUtil, $cacheFactory, $q, broker) {

    var url = '/api2/carhire/details/';
    var timeout;
    var promiseCache =
        $cacheFactory.get('detailPromiseCache') || $cacheFactory('detailPromiseCache');


    // var domain = TRPCONFIG.Domain,
    var service = {
        getCarDetails: getCarDetails,
        rehydrate: rehydrate
    };

    function stringifyOptions(details) {
        details.AdditionalOptions = arrayUtil.map(details.AdditionalOptions, function (o:any) {
            o.OptionId = '' + o.OptionId;
            return o;
        });
        return details;
    }

    function getCarDetails(quote) {
        if (!!quote.CarHireQuote.Details) {
            return $q.when(quote.CarHireQuote.Details);
        }
        if (timeout != null) {
            timeout.resolve('CANCELLED');
        }
        var request = {
            AvailabilitySearchId: quote.AvailabilitySearchId,
            CarHireQuoteId: quote.CarHireQuote.CarHireId
        };
        timeout = $q.defer();
        return $http.post(url + 'get', request, {
            timeout: null,
            customErrCallback:
                function (args) {
                    if (args.status) {
                        broker.publish('carHireRequestFailed');
                    }
                    return true;
                }

        }).then(function (res) {
            promiseCache.remove(res.data.DetailsSearchId);
            timeout = null;
            return stringifyOptions(res.data);
        });
    }

    function rehydrate(id) {
        if (!promiseCache.get(id)) {
            promiseCache.put(id,
                $http.post(url + 'getfromsession', { DetailsSearchId: id }, { ignoreErrors: true })
                .then(function (res) {
                    return stringifyOptions(res.data);
                }, function() {
                    return $q.when('hello');
                }));
        }
        return promiseCache.get(id);
    }

    return service;

}
